export default __webpack_public_path__ + "static/media/antiaging.ece98dd9.jpg";